import React from 'react';
import Modal from '../../component/Inc/Modal';

function PopDeposit(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_deposit">
      <h2 className="pop_tit">입금 하기</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field">입금액 입력</li>
          <li className="input_field">
            <div className="com_input_wrap ">
              <input type="text" className="input" defaultValue={`150,000`} />
            </div>
          </li>
          <li className="tit_field">현금 입금</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <input type="text" className="input big blue" defaultValue={`150,000`} />
              <div className="com_check_box">
                <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                <label htmlFor="chk01">현금영수증</label>
              </div>
            </div>
          </li>
          <div className="btn_container">
            <button className="com_btn orange xs">입금</button>
          </div>
        </ul>
      </div>
    </Modal>
  );
}

export default PopDeposit;
